import AssignmentListOrphanClientAdmin from '../Contents/Operations/Assignments/OrphanedAssignment/AssignmentListOrphanClientAdmin';
import FieldTypesEnum from '../Enums/FieldTypesEnum';
import TabListTableCellWidthEnum from '../Enums/TabListTableCellWidthEnum';
import React from 'react';

export default class OrphanedAssignmentsClientGroupedItem {
  constructor(item) {
    if (item) {
      this.AsSassieSurveyId = item.asSassieSurveyId;
      this.AssignmentsCount = item.assignmentsCount;
      return;
    }
    this.AsSassieSurveyId = '';
    this.AssignmentsCount = '';
  }

  static nameOfTheItemDetailList(item) {
    return `Orphaned - Missing Client (Survey ID: ${item.AsSassieSurveyId})`;
  }

  static NameOfTheIdField() {
    return 'AsSassieSurveyId';
  }

  static Currency() {}

  static CurrencySecondary() {}

  static FieldsToShowInListTable = [
    {
      tabName: 'Assignments',
      tabLabel: 'Assignments',
      icon: 'fa-brands fa-grav fa-2x',
      data: [
        {
          name: OrphanedAssignmentsClientGroupedItem.getAssignmentContent,
          label: 'Assignments',
          width: TabListTableCellWidthEnum.Table,
        },
      ],
    },
  ];

  static FieldsToShowInDataTable() {
    return [
      {
        label: 'Survey ID',
        orderById: 'AsSassieSurveyId',
        data: 'AsSassieSurveyId',
        type: FieldTypesEnum.DataFieldWithDetails,
        minWidth: 70,
      },
      { label: 'Assignments Count', orderById: 'AssignmentsCount', data: 'AssignmentsCount', minWidth: 40 },
    ];
  }

  static getAssignmentContent(item) {
    return <AssignmentListOrphanClientAdmin surveyId={item.AsSassieSurveyId} />;
  }
}
